export default {
  getDay: function (i) {
    let day;
    switch (i) {
      case 0:
        day = "SUN";
        break;
      case 1:
        day = "MON";
        break;
      case 2:
        day = "TUE";
        break;
      case 3:
        day = "WED";
        break;
      case 4:
        day = "THU";
        break;
      case 5:
        day = "FRI";
        break;
      case 6:
        day = "SAT";
    }
    return day;
  },
  getYear: function () {
    return "year";
  },
  getMonth: function (i) {
    let day;
    switch (i) {
      case 0:
        day = "JAN";
        break;
      case 1:
        day = "FEB";
        break;
      case 2:
        day = "MAR";
        break;
      case 3:
        day = "APR";
        break;
      case 4:
        day = "MAY";
        break;
      case 5:
        day = "JUN";
        break;
      case 6:
        day = "JUL";
        break;
      case 7:
        day = "AUG";
        break;
      case 8:
        day = "SEP";
        break;
      case 9:
        day = "OCT";
        break;
      case 10:
        day = "NOV";
        break;
      case 11:
        day = "DEC";
        break;
    }
    return day;
  },
  getFullDay: function (i) {
    let day;
    switch (i) {
      case 0:
        day = "SUNDAY";
        break;
      case 1:
        day = "MONDAY";
        break;
      case 2:
        day = "TUESDAY";
        break;
      case 3:
        day = "WEDNESDAY";
        break;
      case 4:
        day = "THURSDAY";
        break;
      case 5:
        day = "FRIDAY";
        break;
      case 6:
        day = "SATURDAY";
    }
    return day;
  },

  getCurrentTimeZone: function () {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  },

  getDateByLocale(locale, options, date) {
    return new Intl.DateTimeFormat(locale, options).format(date);
  },

  groupBy: function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  },

  updateUrlParameter: function (uri, key, value) {
    // remove the hash part before operating on the uri
    var i = uri.indexOf("#");
    var hash = i === -1 ? "" : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
      uri = uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      uri = uri + separator + key + "=" + value;
    }
    return uri + hash; // finally append the hash as well
  },

  emailVerification: function (o) {
    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regex.test(o);
  },

  noSymbolVerification: function (o) {
    let regex = /^[_A-z0-9]*((-|\s)*[_A-z0-9])*$/g;
    return regex.test(o);
  },
  noNumberVerification: function (o) {
    let regex = /^([0-9]*)$/;
    return regex.test(o);
  },
  isAudioType: function (o) {
    let regex = /\.(mp3|mp4)$/i;
    return regex.test(o);
  },
  onlyNumber: function (o) {
    if (typeof o !== "number") {
      return o.replace(/\D/g, "");
    }
    return o;
  },

  openNewWindow: function (event) {
    event.preventDefault();

    window.open(
      event.currentTarget.href,
      "_blank",
      "location=yes,height=570,width=420,scrollbars=yes,status=yes"
    );
  },

  popupwindow(url, title, w, h) {
    var left = screen.width / 2 - w / 2;
    var top = screen.height / 2 - h / 2;
    return window.open(
      url,
      title,
      "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        top +
        ", left=" +
        left
    );
  },
  getParameterByName: function (name, url) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  removeHTMLTags: function (str) {
    if (str === null || str === "") return false;
    else str = str.toString();

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, "");
  },

  mobileCheck: function () {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  },
  isRealMobile: function () {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
    const isMobileScreen = Math.max(screen.width, screen.height) <= 768;

    const isNotDesktopBrowser = !/Chrome\/[.0-9]* Mobile|EdgA|FxiOS/i.test(userAgent) || !window.chrome;

    // 尝试组合判断
    return isMobileUA && isTouchDevice && isMobileScreen && isNotDesktopBrowser;
  },
  getMobileOperatingSystem: function () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
};
